import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  COMBAT_PHASE,
  DURING_ANY_PHASE,
  DURING_GAME,
  END_OF_COMBAT_PHASE,
  END_OF_TURN,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SHOOTING_PHASE,
  START_OF_COMBAT_PHASE,
  START_OF_HERO_PHASE,
  START_OF_ROUND,
} from 'types/phases'

const CommandTraits = {
  'Shadow-Blooded': {
    effects: [
      {
        name: `Shadow-Blooded - Reaction: You declared the Redeploy command for a Daughters of Khaine unit wholly within 12" of this unit`,
        desc: `Effect: If you roll a 1-3 when determining the distance that unit can move, you can use a value of 4 instead.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'Hand of Khaine': {
    effects: [
      {
        name: `Hand of Khaine`,
        desc: `Declare: Pick an enemy Hero in combat with this unit to be the target.
        Effect: Roll 2D6. If the roll exceeds the target's Health characteristic, it is automatically destroyed. If the target is destroyed by this ability, this unit can use 2 Fight abilities this phase. After the first is used, however, this unit has Strike-Last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  /* 'Sacrificial Overseer': {
    effects: [
      {
        name: `Sacrificial Overseer`,
        desc: `After this general has fought for the first time in the combat phase, if any enemy models were slain by wounds caused by this general's attacks in that phase, this general is said to be revelling in murder until the end of the phase. If this general is revelling in murder, they can fight for a second time in that phase. The strike-last effect applies to this general when they fight for that second time.`,
        when: [COMBAT_PHASE],
      },
    ],
  }, */
  'Murderous Duellist': {
    effects: [
      {
        name: `Murderous Duellist`,
        desc: `Declare: Pick an enemy unit that has no more than 1 model and is in combat with this unit to be target.
        Effect: Roll 2D6. If the roll equals or exceeds the target's Control characteristic, for the rest of the turn, if this unit is in combat with the target when the target is picked to use a Fight ability, all of the target's attacks must target this unit.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'The Croneseers Pariahs (AoR)': {
    effects: [
      {
        name: `Proselyte of Morai-Hag (AoR) - Passive`,
        desc: `Effect: Enemy units cannot use commands while they are in combat with this unit.`,
        when: [DURING_GAME],
      },
    ],
  },
  'Champions of the Arena (AoR)': {
    effects: [
      {
        name: `Hero of the Killing Games (AoR)`,
        desc: `Effect: For the rest of the turn, while a unit is in combat with any enemy Heroes:
        Add 1 to the Attacks, Rend and Damage characteristics of this unit's melee weapons.
        All of its combat attacks must target the same enemy Hero.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Zainthar Kai (AoR)': {
    effects: [
      {
        name: `Khaine's Inheritor (AoR)`,
        desc: `Declare: Pick a visible enemy unit within 12" of this unit to be the target.
        Effect: Roll a D3. On a 2+:
        Inflict an amount of mortal damage on the target equal to the roll.
        Halve the target's Move characteristic until the start of your next turn.`,
        when: [SHOOTING_PHASE],
      },
    ],
  },
  /* 'True Believer': {
    effects: [
      {
        name: `True Believer`,
        desc: `Add 1 to the number of the current battle round when determining the abilities gained by this general from the Blood Rites battle trait (pg 66). This ability and other similar abilities are cumulative.`,
        when: [START_OF_ROUND],
      },
    ],
  },
  'Arcane Mastery': {
    effects: [
      {
        name: `Arcane Mastery`,
        desc: `WIZARD only. This general knows all of the spells from the Lore of Shadows (pg 70) in addition to the other spells it knows.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Fuelled by Revenge': {
    effects: [
      {
        name: `Fuelled by Revenge`,
        desc: `MELUSAI IRONSCALE only. Once per battle, at the start of the combat phase, you can say that this general will wreak Khaine's vengeance. If you do so, until the end of that phase, add 1 to the Attacks characteristic of melee weapons used by friendly MELUSAI units wholly within 12" of this general.`,
        when: [START_OF_COMBAT_PHASE],
      },
    ],
  }, */
} satisfies TItemDescriptions

export default tagAs(CommandTraits, 'command_trait')
